var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-page-base",
    { attrs: { title: "Logs de Reversa - Erros de solicitação " } },
    [
      _c("sc-grid", {
        attrs: {
          data: _vm.logsReverse,
          total: _vm.logsReverse.length,
          loading: _vm.loading,
          rules: _vm.rules,
          "default-sort-column": "“started”",
          "default-sort-direction": "“desc”",
          "default-filters": _vm.defaultFilters,
          "has-backend-sorting": false,
          tableAttrs: {
            sorting: true
          }
        },
        on: { submit: _vm.getlogsReverse },
        scopedSlots: _vm._u([
          {
            key: "filters",
            fn: function(ref) {
              var filters = ref.filters
              return [
                _c("sc-logs-reverse-filters", {
                  attrs: { filters: filters, rules: _vm.rules }
                })
              ]
            }
          },
          {
            key: "filters-actions",
            fn: function(ref) {
              var isLoading = ref.isLoading
              return [
                _c("sc-button", {
                  attrs: {
                    type: "submit",
                    theme: "primary",
                    text: "Buscar",
                    loading: isLoading
                  }
                })
              ]
            }
          },
          {
            key: "table-columns",
            fn: function(ref) {
              var props = ref.props
              return [
                _c(
                  "sc-table-column",
                  { attrs: { label: "Status", field: "status", sortable: "" } },
                  [
                    _vm._v(
                      "\n          " + _vm._s(props.row.status) + "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "sc-table-column",
                  {
                    attrs: {
                      label: "Date e hora",
                      field: "started",
                      sortable: ""
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm._f("date")(
                            props.row.started,
                            "DD/MM/YYYY HH:mm:ss"
                          )
                        ) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "sc-table-column",
                  {
                    attrs: {
                      label: "Data ultima atualização",
                      field: "modified",
                      sortable: ""
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm._f("date")(
                            props.row.modified,
                            "DD/MM/YYYY HH:mm:ss"
                          )
                        ) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "sc-table-column",
                  {
                    attrs: {
                      label: "Transportadora",
                      field: "logistic_provider_name",
                      sortable: ""
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(props.row.logistic_provider.name) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "sc-table-column",
                  { attrs: { label: "Valores/Mensagens", field: "message" } },
                  [
                    _vm._v(
                      "\n          " + _vm._s(props.row.message) + "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "sc-table-column",
                  {
                    attrs: {
                      label: "Quantidade de retentativas",
                      field: "retry_times",
                      sortable: ""
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(props.row.retry_times) +
                        "\n      "
                    )
                  ]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ce975b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ce975b2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-analytic/features/logs/pages/reverse/PageLogsReverse.vue
// module id = null
// module chunks = 